<div class="container-fluid min-vh-100 p-2">
  <div class="mx-auto w-100">
    <section class="risk-framework-hero d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3 mb-4">
      <div class="flex-grow-1">
        <p class="risk-framework-title text-xl fw-bold mb-1">
          {{ hero.title }}
        </p>
        <p class="risk-framework-subtitle text-x mb-0">
          {{ hero.description }}
        </p>
      </div>

      <button type="button" class="btn btn-primary-dark text-xs align-items-center justify-content-center gap-2">
        <i class="bi bi-plus-lg me-1 "></i>
        <span>Create Framework</span>
      </button>
    </section>

    <section class="risk-framework-card rounded-4 p-2 p-lg-3">
      <div class="d-flex justify-content-between align-items-center gap-3 px-2 px-lg-3 pt-2 pb-3">
        <div class="d-flex align-items-center gap-2">
          <span class="risk-framework-card-icon d-inline-flex align-items-center justify-content-center rounded-2">
            <i class="bi bi-archive-fill"></i>
          </span>
          <span class="text-x fw-bold">Framework Directory</span>
        </div>

        <div class="d-flex align-items-center gap-2">
          <button type="button" class="risk-framework-toolbar-btn btn d-inline-flex align-items-center justify-content-center">
            <i class="bi bi-funnel-fill"></i>
          </button>
          <button type="button" class="risk-framework-toolbar-btn btn d-inline-flex align-items-center justify-content-center">
            <i class="bi bi-download"></i>
          </button>
        </div>
      </div>

      <div class="risk-framework-table-wrap">
        <table class="table align-middle mb-0 risk-framework-table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">TYPE</th>
              <th scope="col">RISK FRAMEWORK</th>
              <th scope="col">DESCRIPTION</th>
              <th scope="col">STATUS</th>
              <th scope="col" class="text-end">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="framework in frameworks" :key="framework.id">
              <td class="risk-framework-id">
                {{ format_framework_id(framework.frameworkId) }}
              </td>
              <td>
                <span class="risk-framework-type-pill">
                  {{ framework.type.toUpperCase() }}
                </span>
              </td>
              <td class="fw-semibold risk-framework-name">
                {{ framework.title }}
              </td>
              <td class="risk-framework-description">
                {{ framework.description }}
              </td>
              <td>
                <span class="risk-framework-status d-inline-flex align-items-center gap-2">
                  <span class="risk-framework-status-dot"></span>
                  <span>{{ framework.status }}</span>
                </span>
              </td>
              <td class="text-end">
                <div class="risk-framework-actions d-inline-flex flex-column align-items-end gap-1">
                  <button type="button" class="btn btn-link p-0 risk-framework-action-manage text-uppercase text-xs fw-bold text-decoration-none">
                    Manage
                  </button>
                  <button type="button" class="btn btn-link p-0 risk-framework-action-deactivate text-uppercase text-xs fw-bold text-decoration-none">
                    Deactivate
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</div>
